import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface DiscardChangesModalProps {
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const DiscardChangesModal = ({ onConfirm, onClose }: DiscardChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('edit-plan-discard-title')}
      message={t('edit-plan-discard-message')}
      warning={t('edit-plan-discard-warning')}
      cancelLabel={t('edit-plan-discard-cancel')}
      confirmLabel={t('edit-plan-discard-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
